module.exports = __webpack_public_path__ + "static/img/topWinnerBg.6da0069.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/topWinnerBg.webp
// module id = KGz7
// module chunks = 0